<template>
  <div>
    <v-row no-gutters class="form-group" v-if="!noLabel">
      <v-col :cols="12">
        <span style="display:inline-block;" v-if="label !== ''" class="item-label">{{ label }}</span>
        <span style="display:inline-block;color:white;" v-else class="item-label" />
        <span style="display:inline-block;">
          <label class="form-group-label">
            <span v-if="required && !requiredMarkHidden" class="mandatory">必須</span>
          </label>
        </span>
        <span v-if="unusableBiko === false && !readonly" style="float:right;">
          <!-- 変更点: クリック時にsetClockModeを呼び出し、内部状態を基準にメッセージを切り替える -->
          <v-btn
            @click="setClockMode(!internalClockUsable)"
            color="primary"
            :small="true"
            :message="internalClockUsable ? '時刻を明確にしている場合はこちらをClick' : '時刻を曖昧指定する場合はこちらをClick'"
            dense
            class="px-1 item-label-append"
          >
            <!-- 変更点: v-ifの条件をinternalClockUsableに変更 -->
            <span v-if="!internalClockUsable"><v-icon x-small>mdi-clock-outline</v-icon>明確な時刻を指定する</span>
            <span v-else><v-icon x-small>mdi-pencil</v-icon>曖昧な時刻を指定する</span>
          </v-btn>
        </span>
      </v-col>
    </v-row>
    <v-row :style="'background-color:' + (required ? '#FFEDEE;' : 'white;') + (borderless ? '' : readonly ? 'border-bottom: 1px solid #1F2B38;' : '; border: 1px solid #CDD6DD; border-radius:5px;')" no-gutters>
      <v-col class="py-0" :cols="12">
        <div class="px-0" style="display: inline-block;width:9rem;">
          <dd-date-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="computedDate"
            label=""
            :readonly="readonly"
            :required="required"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            @click="onClick"
            :multiline="multiline"
          />
        </div>
        <!-- 変更点: v-ifの条件をinternalClockUsableに変更 -->
        <div v-if="internalClockUsable" class="px-0" style="display: inline-block;width:6rem;">
          <dd-time-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="computedTime"
            label=""
            :readonly="readonly"
            :required="required"
            :tabindex="readonly ? -1 : 0"
            @click="onClick"
            :multiline="multiline"
          />
        </div>
        <div v-else class="px-0" style="display: inline-block;width:8.125rem;">
          <dd-text-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="computedTimeBiko"
            label=""
            :length="100"
            :readonly="readonly"
            :required="required"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            :valueType="Ctrls.InputTypes.Free"
            @click="onClick"
          />
        </div>
        <div class="pr-1 pt-1" style="float: right;">
          <!-- 変更点: v-ifの条件をinternalClockUsableに変更 -->
          <v-menu v-if="!readonly" v-model="isShowCalendar" :close-on-content-click="false" origin="top left" :min-width="!internalClockUsable ? '300px' : '580px'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                color="primary"
                elevation="0"
                tabindex=-1
                icon
                dark
                small
                @click="onIconClick">
                <v-icon color="#83bde5">mdi-calendar-clock</v-icon>
              </v-btn>
            </template>
            <v-card elevation=0>
              <v-card-text>
                <v-row style="background-color:#E9F1F7; height:36px" no-gutters>
                  <v-col :cols="12" class="px-2">
                    <div style="display: inline-block;width:60px">
                      <span class="input-info">選択日時</span>
                    </div>
                    <div style="display: inline-block;width:180px">
                      <dd-text-box-inside
                        v-model="selectedDateTime"
                        :readonly="true"
                      />
                    </div>
                    <div v-if="unusableBiko === false" class="pr-1 pt-1" style="float: right;">
                      <!-- 変更点: v-ifの条件とクリック時の処理をsetClockModeに変更 -->
                      <dd-icon-button-with-tooltip
                        v-if="internalClockUsable"
                        @click="setClockMode(false)"
                        icon="mdi-delete-clock-outline"
                        color="primary"
                        message="時計を非表示にし、時間を任意入力にします"
                      />
                      <dd-icon-button-with-tooltip
                        v-else
                        @click="setClockMode(true)"
                        icon="mdi-clock-end"
                        color="primary"
                        message="時計を表示し、時刻を指定します"
                      />
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <!-- 変更点: :colsの条件をinternalClockUsableに変更 -->
                  <v-col :cols="!internalClockUsable ? 12 : 6" class="px-7">
                    <vc-date-picker
                      elevation="0"
                      v-model="calendarDate"
                      style="border: none"
                      :step="1"
                      :model-config="modelConfig"
                      :day-format="date => new Date(date).getDate()"
                      :max="calendarMax"
                      :min="calendarMin"
                      @input="onCalendarInput(false)"
                    />
                  </v-col>
                  <!-- 変更点: v-ifの条件をinternalClockUsableに変更 -->
                  <v-col v-if="internalClockUsable" :cols="6" class="px-2">
                    <v-time-picker
                      v-model="clockTime"
                      :width="260"
                      no-title
                      format="24hr"
                      scrollable
                      min="0:00"
                      max="23:59"
                      @click:minute="onClockInput"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row no-gutters>
                  <!-- 変更点: :colsの条件をinternalClockUsableに変更 -->
                  <v-col :cols="!internalClockUsable ? 12 : 6">
                    <v-row no-gutters>
                      <dd-custom-button @click="onCalendarInput(true)">適用</dd-custom-button>
                      <dd-transparent-button :minWidth="70" @click="isShowCalendar = false">キャンセル</dd-transparent-button>
                      <v-spacer />
                      <!-- 変更点: v-ifの条件をinternalClockUsableに変更 -->
                      <dd-transparent-button :minWidth="130" @click="setCurrentDate(1)" v-if="!internalClockUsable">
                        <v-icon color="#8398e5">mdi-calendar-today</v-icon>
                        <span style="color:#8398e5">現在日付を使用する</span>
                      </dd-transparent-button>
                    </v-row>
                  </v-col>
                  <!-- 変更点: v-ifの条件をinternalClockUsableに変更 -->
                  <v-col v-if="internalClockUsable" :cols="6">
                    <v-row no-gutters>
                      <v-spacer />
                      <dd-transparent-button :minWidth="130" @click="setCurrentDateTime(1)">
                        <v-icon color="#8398e5">mdi-calendar-today</v-icon>
                        <span style="color:#8398e5">現在日時を使用する</span>
                      </dd-transparent-button>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { VTextField } from 'vuetify/lib'
import inputMixin from '@/mixins/inputMixins'
import complements from '@/rahmen/complement'
import date from '@/ddv2.library/date'
import controls from '@/rahmen/controls'

import DdCustomButton from '@/components/DdCustomButton'
import DdDateBoxInside from '@/components/DdDateBoxInside'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdTextBoxInside from '@/components/DdTextBoxInside.vue'
import DdTimeBoxInside from '@/components/DdTimeBoxInside'
import DdTransparentButton from '@/components/DdTransparentButton'

export default {
  name: 'DdDateRangeBox',
  extends: VTextField,
  components: {
    DdCustomButton,
    DdDateBoxInside,
    DdIconButtonWithTooltip,
    DdTextBoxInside,
    DdTimeBoxInside,
    DdTransparentButton
  },
  mixins: [inputMixin],
  props: {
    // === ここからが修正箇所 ===
    clockUsable: {
      type: Boolean,
      default: true
    },
    // === ここまでが修正箇所 ===
    label: String,
    inputDate: {
      type: String,
      default: ''
    },
    inputTime: {
      type: String,
      default: ''
    },
    inputTimeBiko: {
      type: String,
      default: ''
    },
    unusableBiko: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    max: String,
    min: String,
    errorMessages: String,
    no_title: {
      type: Boolean,
      default: true
    },
    tooltipText: {
      type: String,
      default: ''
    },
    enableToolTip: {
      type: Boolean,
      default: true
    },
    tooltipLeft: {
      type: Boolean,
      default: false
    },
    tooltipTop: {
      type: Boolean,
      default: false
    },
    tooltipRight: {
      type: Boolean,
      default: false
    },
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    noLabel: {
      type: Boolean,
      default: false
    },
    requiredMarkHidden: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    },
    multiline: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    Ctrls: controls,
    phtext: '',
    hasFocus: false,
    invalidMessage: '',
    innerValue: '',
    isShowCalendar: false,
    calendarDate: '',
    clockTime: '',
    // === ここからが修正箇所 ===
    internalClockUsable: true, // コンポーネント内部の状態管理用
    // clockUsable: true, // dataからpropsに移動
    // === ここまでが修正箇所 ===
    defaultMax: '2999/12/31',
    defaultMin: '2000/01/01',
    modelConfig: {
      type: 'string',
      mask: 'YYYY-MM-DD'
    }
  }),
  // === ここからが修正箇所 ===
  watch: {
    clockUsable: {
      handler (newValue) {
        this.internalClockUsable = newValue
      },
      immediate: true
    }
  },
  // === ここまでが修正箇所 ===
  computed: {
    computedDate: {
      get () {
        return this.inputDate
      },
      set (value) {
        this.$emit('update:inputDate', value)
      }
    },
    computedTime: {
      get () {
        return this.inputTime
      },
      set (value) {
        this.$emit('update:inputTime', value)
      }
    },
    computedTimeBiko: {
      get () {
        return this.inputTimeBiko
      },
      set (value) {
        this.$emit('update:inputTimeBiko', value)
      }
    },
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    calendarMax () {
      if (this.max) {
        return this.max.split('/').join('-')
      }
      return undefined
    },
    calendarMin () {
      if (this.min) {
        return this.min.split('/').join('-')
      }
      return undefined
    },
    selectedDateTime () {
      return this.computedDate + ' ' + this.computedTime
    }
  },
  methods: {
    // === ここからが修正箇所 ===
    setClockMode (isUsable) {
      this.internalClockUsable = isUsable
      this.$emit('update:clockUsable', isUsable)
    },
    // === ここまでが修正箇所 ===
    onIconClick: function (e) {
      console.log('DdDateRangeBox.onIconClick inputDate - inputTime : ', this.computedDate)
      if (![undefined, null, ''].includes(this.computedDate)) {
        this.calendarDate = this.computedDate.split('/').join('-')
      }
    },
    onCalendarInput: function (closeFlg) {
      console.log('calendarDate is ', this.calendarDate)
      this.computedDate = this.calendarDate.split('-').join('/')
      // 変更点: internalClockUsableを参照
      if (!this.internalClockUsable) this.isShowCalendar = false
      if (closeFlg) this.isShowCalendar = false
    },
    onClockInput: function (e) {
      console.log(e)
      console.log('clockTime is ', this.clockTime)
      this.computedTime = this.clockTime

      if (![undefined, null, ''].includes(this.computedDate) && ![undefined, null, ''].includes(this.computedTime)) this.isShowCalendar = false
    },
    // onMomentControlClickメソッドは直接setClockModeを呼び出すように変更したため不要
    // onMomentControlClick: function () {
    //   this.clockUsable = !this.clockUsable
    // },
    onClick: function () {
      this.isShowCalendar = false
    },
    setCurrentDate: function () {
      if (this.readonly) return

      console.log('setCurrentDate')
      this.computedDate = date.getCurrentDate()

      this.isShowCalendar = false
    },
    setCurrentDateTime: function () {
      if (this.readonly) return

      console.log('setCurrentDate')
      this.computedDate = date.getCurrentDate()

      const now = new Date()
      const hm = complements.parseTime(`${now.getHours()}:${now.getMinutes()}`)
      this.computedTime = hm

      this.isShowCalendar = false
    }
  }
}
</script>
<style scoped>
/* styleは変更なし */
.v-picker.v-card.v-picker--date {
  position: absolute;
  z-index: 500;
}
.mdi-calendar::before {
  color: #2196F3;
}
.v-menu__content.theme--light {
  height: 352px !important;
  background-color: #FFF;
}
::v-deep .theme--light.v-btn.v-btn--disabled.primary {
  color: #4D90FE !important;
}
.item-label-append {
    border-radius:10px !important;
    color: #fff !important;
    font-size: 7px !important;
    font-weight: normal !important;
    height: 15px !important;
    letter-spacing: 0px !important;
    text-align: left !important;
    margin-left: 4px;
    padding-top: 1px;
    padding-bottom: 1px;
    padding-left: 4px;
    padding-right: 5px;
    vertical-align: text-top;
}
.input-info {
  font-size:small;
  font-weight:bold;
}
</style>
